/**
 * This module reads and makes available
 * hidden or otherwise QA ready features
 * in the application that we do not want to release,
 * but work depends on them
 *
 * A feature is disabled by default,
 * unless localStorage.ENABLE_FEATURE is set
 *
 * If ENABLE_SOME_FEATURE is set to a truthy value in lS,
 * simply use `import features from 'core/features';` and
 * then simply evaluate if (features.someFeature
 *
 */
import { camelCase } from 'lodash';

const features = Array.from(Array(localStorage.length).keys()) // localStorage size
  .map(key => localStorage.key(key)) // converted to keys
  .filter(key => key.indexOf('ENABLE_') === 0 && localStorage[key] === 'true') // only enabled ones
  .map(key => camelCase(key.substr(7))) // removing ENABLE_ and switching to camel case
  .reduce((fs, f) => ({ ...fs, [f]: true }), {});

const featuresList = Object.keys(features).join(', ');
if (featuresList) {
  console.warn(
    `Warning, several features (${featuresList}) were marked as enabled in localStorage.
    This might lead to surprises when the application is deployed and tested in prod.
    If you aren't sure, remove any 'ENABLE_*' keys from localStorage.
    `,
  );
}

export default features;
